export const TIME_GRANULARITIES = [
    { label: 'W/O Grouping', value: 'null' },
    { label: 'Second', value: 'second' },
    { label: 'Minute', value: 'minute' },
    { label: 'Hour', value: 'hour' },
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' },
]


export const GRANULARITY_DATE_RANGE = [
    { label: 'Custom', value: 'custom' },
    { label: 'All time', value: 'allTime' },
    { label: 'Today', value: 'Today' },
    { label: 'Yesterday', value: 'Yesterday' },
    { label: 'This Week', value: 'This Week' },
    { label: 'This Month', value: 'This Month' },
    { label: 'This Quarter', value: 'This Quarter' },
    { label: 'This Year', value: 'This Year' },    
    { label: 'Last 7 Days', value: 'Last 7 Days' },
    { label: 'From 7 days ago to now', value: 'from 7 days ago to now' },
    { label: 'Last 30 Days', value: 'Last 30 Days' },
    { label: 'From 30 days ago to now', value: 'from 30 days ago to now' },
    { label: 'Last 90 Days', value: 'Last 90 Days' },
    { label: 'Last 365 Days', value: 'Last 365 Days' },
    { label: 'From 365 days ago to now', value: 'from 365 days ago to now' },
    { label: 'Last Week', value: 'Last Week' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Last Quarter', value: 'Last Quarter' },
    { label: 'Last Year', value: 'Last Year' },
]

export const COMPARE_DATE_RANGE = [
    { label: 'Custom', value: 'custom' },
    { label: 'Today', value: 'Today' },
    { label: 'Yesterday', value: 'Yesterday' },
    { label: 'This Week', value: 'This Week' },
    { label: 'This Month', value: 'This Month' },
    { label: 'This Quarter', value: 'This Quarter' },
    { label: 'This Year', value: 'This Year' },
    { label: 'Last 7 Days', value: 'Last 7 Days' },
    { label: 'Last 30 Days', value: 'Last 30 Days' },
    { label: 'Last Week', value: 'Last Week' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Last Quarter', value: 'Last Quarter' },
    { label: 'Last Year', value: 'Last Year' },
]

export const TIME_GRANULARITIES_DATE_FORMAT = [
    {label: '27-09-2022',value: 'DD-MM-YYYY'},
    {label:'09-27-2022',value: 'MM-DD-YYYY'},
    {label:'2022-09-27',value: 'YYYY-MM-DD'},
    {label:'27 September, 2022',value: 'DD MMMM, YYYY'},
    {label:'September 27, 2022',value: 'MMMM DD, YYYY'},
    {label:'Monday, September 27, 2022',value: 'dddd, MMMM DD, YYYY'}
]
